import { createContext, useMemo, useReducer } from "react";

import type { Dispatch, ReactNode } from "react";

interface SubscriptionProviderProps {
  children: ReactNode;
}

interface SubscriptionContextState {
  subscription: null | CondensedSubscription;
}

interface SetSubscriptionAction {
  subscription: CondensedSubscription;
  type: "setSubscription";
}

interface ClearSubscriptionAction {
  type: "clearSubscription";
}

type SubscriptionActions = SetSubscriptionAction | ClearSubscriptionAction;

interface SubscriptionContextDispatch {
  dispatch: Dispatch<SubscriptionActions>;
}

const INITIAL_STATE: SubscriptionContextState = {
  subscription: null,
};

export const subscriptionContext = createContext<
  SubscriptionContextState & SubscriptionContextDispatch
>({
  ...INITIAL_STATE,
  dispatch: () => null,
});

function reducer(
  state: SubscriptionContextState,
  action: SubscriptionActions,
): SubscriptionContextState {
  switch (action.type) {
    case "clearSubscription":
      return {
        subscription: null,
      };
    case "setSubscription": {
      return {
        subscription: action.subscription,
      };
    }
    default:
      return state;
  }
}

export function SubscriptionProvider(props: SubscriptionProviderProps) {
  const { children } = props;
  const [state, dispatch] = useReducer(reducer, INITIAL_STATE);
  const memoState = useMemo(() => ({ ...state, dispatch }), [state]);

  return (
    <subscriptionContext.Provider value={memoState}>
      {children}
    </subscriptionContext.Provider>
  );
}
